import { User } from './user.model';
import { DirectionTypeEnum } from './restaurant.model';
import { Refund } from './refund.model';
import { OrderStatus } from '../enums/order-state/order-status';
import { Permission } from './permission.model';

export interface Order {
  id: number;
  restaurant: OrderRestaurant;
  user: User;
  items: OrderItem[];
  service_items: OrderServiceItem[];
  refunds: Refund[];
  direction: DirectionTypeEnum;
  courier: Courier;
  paid: boolean;
  status: OrderStatus;
  created_at: string;
  delivery_date: string;
  expected_date: string;
  paid_at: string;
  close_at: string;
  total_price: number;
  order_history: OrderHistory[];
  permission: Permission;
  payment_type: string;
  repeat: boolean;
  preparation_time: number;
  asap: boolean;
  fulfillment: Fulfillment | null;
  total_refunded: number;
  payment_gateway?: string;
  order_purpose: string;
}

export class OrderRestaurant {
  id!: number;
  name!: string;
  time_zone!: string;
  delivery_available!: boolean;
  currency!: string;
  company_title!: string;
  logo_url!: string;
}

export enum OrderType {
  takeaway = 'TAKEAWAY',
  delivery = 'DELIVERY',
  eat_here = 'EAT_HERE'
}

export interface OrderHistory {
  created: string;
  orderStatus: string;
  userId: number;
  userFullName: string;
}

export function getNextStateForOrder(order: Order): string | undefined {
  switch (order.status) {
    case OrderStatus.PAID:
      return 'accept';
    case OrderStatus.ACCEPTED_BY_RESTAURANT:
      return 'ready';
    case OrderStatus.ACCEPTED_BY_COURIER:
      return 'accept';
    case OrderStatus.PREPARED:
      return 'close';
  }
}

export class Fulfillment {
  full_name!: string;
  fullName!: string;
  address_line!: string;
  entry_code!: string;
  apartment_no!: string;
  floor!: string;
  delivery_instruction!: string;
  phone!: string;
  latitude!: number;
  longitude!: number;
  table_number!: number;
  room_number!: number;
}

export class OrderItem {
  id!: number;
  article: any;
  variations!: {
    id: number;
    price: number;
    removed: boolean;
    name: string;
    description: string;
    is_default: boolean;
    meal_id: number;
    var_group: string;
  }[];
  addons!: {
    id: number;
    price: number;
    removed: boolean;
    name: string;
  }[];
  comment!: string;
  item_price!: number;
  vat!: number;
  number_of_items!: number;
  number_of_refunded_items!: 0;
  total_refunded!: 0;
  sidemeal?: any;
}

export interface OrderServiceItem {
  id: number;
  price: number;
  vat: number;
  service_type: string;
  type: string;
  total_refunded: 0;
}

export class RejectRequest {
  comment!: string;
}

export interface Courier {
  fullName: string;
  id: number;
  phone: string;
}
